"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENABLE_RSSOT_BDM_RULES = void 0;
exports.ENABLE_RSSOT_BDM_RULES = {
    CONTACT_ACCOUNT_ROLES: 'CONTACT_ACCOUNT_ROLES',
    CONTACT_ENTITLEMENTS: 'CONTACT_ENTITLEMENTS',
    CONTACT_TRANSACTION_ACCOUNTS: 'CONTACT_TRANSACTION_ACCOUNTS',
};
